import { render } from "./ProductTyreSizeLookup.vue?vue&type=template&id=b714bda2"
import script from "./ProductTyreSizeLookup.vue?vue&type=script&lang=js"
export * from "./ProductTyreSizeLookup.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__